import { useMount } from 'react-use';

import { InteractiveTable, useInteractiveTableContext } from '@dreryk/react-components';

import { isEmpty } from '~libs.typescript';

import { translationKeys } from '../../../../translations';
import { EmergencyNotificationSmsConfigurationContactPersonValue } from '../EmergencyNotificationSmsConfigurationContactPersonsField.types';

import { createEmptyEmergencyNotificationSmsConfigurationContactPersonValue } from './EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable.utils';

export const EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableAddRow = (): JSX.Element => {
   const { addRow, getValues } = useInteractiveTableContext<EmergencyNotificationSmsConfigurationContactPersonValue>();

   useMount(() => {
      if (isEmpty(getValues())) {
         addRow(createEmptyEmergencyNotificationSmsConfigurationContactPersonValue(), 'append');
      }
   });

   return (
      <InteractiveTable.AddRowButton<EmergencyNotificationSmsConfigurationContactPersonValue>
         label={translationKeys.addNumber}
         onAddRow={createEmptyEmergencyNotificationSmsConfigurationContactPersonValue}
         behavior={'append'}
      />
   );
};
